<!--这个组件非常重要！！！！！！！！！！！！！！！！！！！！！！！它并没有页面-->
<!--它在路由中获取订单信息，根据订单信息和电签规则控制程序走向对应的流程-->
<template>
</template>

<script>
// import emkt from '../emkt'
import wx from 'wx'
import emkt from '../emkt'

/**
 * 电签规则：
 * @author Anya
 */
export default {
  name: 'centerController',
  mounted () {
    this.init()
  },
  data () {
    return {
      solutionId: null,
      bOrders: {}
    }
  },
  methods: {
    init () {
      this.$weui.loading('正在提交数据！')
      if (emkt.isWapp) {
        this.bOrders = JSON.parse(this.$route.query.bOrders)
        this.solutionId = JSON.parse(this.$route.query.solution)[0]
      } else {
        this.bOrders = this.$route.params.bOrders
        this.solutionId = this.$route.params.solution
      }
      if (this.bOrders[0].orderType === 3) {
        this.gcapi('loLoadSolutionDetail', this.solutionId).then((res) => {
          if (res.body.code === 0) {
            let solution = JSON.parse(res.body.result)
            solution.operationType = 30
            solution.children.forEach(i => {
              i.groups.forEach(it => {
                if (it.parameterValues && it.parameterValues.length > 0) {
                  it.parameterValues.forEach(ite => {
                    if (ite.dataType) {
                      ite.duplicateDataType = ite.dataType
                    }
                  })
                }
              })
              if (i.parameterValues && i.parameterValues.length > 0) {
                i.parameterValues.forEach(item => {
                  item.duplicateDataType = item.dataType
                })
              }
            })
            this.gcapi('loUpdateSolutionInfo', JSON.stringify(solution)).then((res) => {
              console.log(res.body, '请求审核请求返回')
              if (res.body.code === 0) {
                console.log(JSON.stringify(this.bOrders))
                this.gcapi('orderPay', this.bOrders).then(response => {
                  this.$weui.loading().hide()
                  let order = response.body.result[0]
                  if (response.body.code === 0) {
                    if (order.status === 12) {
                      alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单')
                      if (emkt.isWapp) {
                        wx.miniProgram.switchTab({url: '/pages/cart/cart'})
                      } else {
                        this.$router.replace({name: 'cart'})
                      }
                    // todo 常量
                    } else if (order.status === emkt.ORDER_STATUS_CHECK || order.status === emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === emkt.ORDER_STATUS_SUBMITTED) {
                      this.$router.replace({name: 'submitSuccess', query: {info: true, orderStatus: order.status}})
                    } else if (order.status === 15) {
                      this.$router.replace({name: 'promotions', query: {orderId: order.id, cc: true}})
                    } else if (order.status === 3) {
                      this.$router.replace({name: 'WeappSuccessPay', params: {orderId: order.id}})
                    }
                  }
                })
              }
            })
          } else {
            this.$weui.topTips('获取详情失败，请联系客服解决，方案ID：' + this.solutionId)
          }
          console.log(res.body.result)
        })
      } else {
        this.gcapi('orderPay', this.bOrders).then(response => {
          this.$weui.loading().hide()
          let order = response.body.result[0]
          if (response.body.code === 0) {
            if (order.status === 12) {
              alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单')
              if (emkt.isWapp) {
                wx.miniProgram.switchTab({url: '/pages/cart/cart'})
              } else {
                this.$router.replace({name: 'cart'})
              }
            } else if (order.status === emkt.ORDER_STATUS_CHECK || order.status === emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === emkt.ORDER_STATUS_SUBMITTED) {
              this.$router.replace({name: 'submitSuccess', query: {info: true, orderStatus: order.status}})
            } else if (order.status === 15) {
              this.$router.replace({name: 'promotions', query: {orderId: order.id, cc: true}})
            } else if (order.status === 3) {
              this.$router.replace({name: 'WeappSuccessPay', params: {orderId: order.id}})
            } else if (order.status === emkt.ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
              this.$weui.topTips('提交订单失败，请联系客服或重新提交订单')
              this.$router.replace({name: 'WeappMyOrders'})
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// centerController.vue?ae9a3cd2